import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_432: DocMigration = {
  maxSchemaVersion: "0.0.432",
  description: "Change all plant props to foliage props",
  apply(json: any) {
    for (const settings of Object.values(json.settings) as any[]) {
      if (settings.type !== "EXTERIOR_PROP_SETTINGS" && settings.type !== "INTERIOR_PROP_SETTINGS") {
        continue;
      }

      const propTypes = settings.propTypes;

      if (propTypes) {
        for (const propId in propTypes) {
          const prop = propTypes[propId];
          if (plantAssetIds.includes(prop.propAssetId)) {
            prop.category = "FOLIAGE";
          }
        }
      }
    }

    return json;
  },
};

const plantAssetIds = [
  1401, //Plant_Bush_24x24x24_Strands_01
  1379, //Plant_Bush_36x24x24_Box_01
  1380, //Plant_Bush_36x24x24_Box_02
  1381, //Plant_Bush_36x24x24_Box_03
  1382, //Plant_Bush_36x36x36_Round_01
  1402, //Plant_Bush_36x36x36_Round_02
  1403, //Plant_Bush_36x36x36_Round_03
  1383, //Plant_Bush_36x36x72_Tall_01
  1384, //Plant_Bush_48x30x30_Oval_01
  1385, //Plant_Bush_48x48x48_Round_01
  847, //Plant_Tree_BirchRiver_01
  848, //Plant_Tree_BirchRiver_02
  849, //Plant_Tree_CypressLeyland_01
  850, //Plant_Tree_CypressLeyland_02
  851, //Plant_Tree_MagnoliaFull_01
  852, //Plant_Tree_MagnoliaFull_02
  853, //Plant_Tree_MapleRed_01
  854, //Plant_Tree_MapleRed_02
  855, //Plant_Tree_OakWhite_01
  856, //Plant_Tree_OakWhite_02
  857, //Plant_Tree_PineLoblolly_01
  858, //Plant_Tree_PineLoblolly_02
  859, //Plant_Tree_PoplarYellow_01
  860, //Plant_Tree_PoplarYellow_02
  861, //Plant_Tree_SweetGum_01
  862, //Plant_Tree_SweetGum_02
];

export default migration_0_0_432;
